module.exports = __webpack_public_path__ + "static/media/YB5F12_10.ef37c623.jpg";